import { render, staticRenderFns } from "./FeatureCardShowButtons.vue?vue&type=template&id=38aa637f&scoped=true&"
import script from "./FeatureCardShowButtons.vue?vue&type=script&lang=js&"
export * from "./FeatureCardShowButtons.vue?vue&type=script&lang=js&"
import style0 from "./FeatureCardShowButtons.vue?vue&type=style&index=0&id=38aa637f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aa637f",
  null
  
)

export default component.exports